import React, { useState, useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import { useDispatch } from "react-redux";
import MessageAlert from "../sharedComponents/messageAlert";
import { useTranslation } from "react-i18next";
import { GalbElHabeb } from "../../redux/reducer/productReducer";
import GalbElHabebPopup from "./GalbElHabebPopup";
import { dir } from "i18next";
import useLanguageDirection from "../../hooks/useLanguageDirection";

const CopyLinkWithoutBackgroundV2 = () => {
  const [productLink, setProductLink] = useState("");
  const [message, setMessage] = useState(null);
  const [messageType, setMessageType] = useState(null);
  const dispatch = useDispatch();
  const [showAlert, setShowAlert] = useState(false);
  // const { t } = useTranslation();
  const { t, i18n } = useTranslation();
  const [isDisabled, setIsDisabled] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [result, setResult] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);
  const direction = useLanguageDirection();
  useEffect(() => {
    if (message) {
      setShowAlert(true);
      const timer = setTimeout(() => setShowAlert(false), 2000);
      return () => clearTimeout(timer);
    }
  }, [message]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  const handelPopupGalpElhabeb = () => {
    setIsOpen(false);
  };

  const handleGalbElHabeb = async () => {
    setIsOpen(false);

    if (!productLink.trim()) {
      setMessageType("error");
      setMessage(t("enterProductLink"));
      return;
    }

    setIsDisabled(true);
    setIsLoading(true);

    const data = { link: productLink, count: 1 };

    try {
      const res = await dispatch(GalbElHabeb(data)).unwrap();
      setResult(res);
      setIsOpen(true);
    } catch (error) {
      console.error("Error:", error);
      setMessageType("error");
      setMessage(t("somethingWentWrong"));
    } finally {
      setIsDisabled(false);
      setIsLoading(false);
      setProductLink("");
    }
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    if (!isLoading && !isDisabled) handleGalbElHabeb();
  };

  return (
    <div className="flex flex-col items-center justify-center w-full h-auto lg:py-1">
      <form className="w-full" onSubmit={handleFormSubmit}>
        {showAlert && <MessageAlert type={messageType} message={message} />}
        <div className="relative w-full">
          <input
            type="text"
            placeholder={t("LinkProduct")}
            dir={i18n.language === "ar" ? "rtl" : "ltr"}
            className={`w-full p-3 text-gray-700 bg-white border shadow-sm lg:py-5 lg:placeholder:text-lg focus:ring focus:ring-yellow-400 focus:outline-none ${
              i18n.language === "ar" ? "pr-2" : "pl-2"
            }`}
            value={productLink}
            onChange={(e) => setProductLink(e.target.value)}
          />

          <div
            className={`absolute flex items-center justify-end -translate-y-1/2 lg:end-3 md:end-2 end-2  top-1/2`} dir={direction}
          >
            {isLoading ? (
              <div className="flex items-center justify-center w-10 h-10 animate-spin">
                <svg className="w-full h-full" viewBox="0 0 50 50">
                  <circle
                    cx="25"
                    cy="25"
                    r="20"
                    fill="none"
                    stroke="#facc15"
                    strokeWidth="5"
                    strokeLinecap="round"
                    strokeDasharray="120"
                    strokeDashoffset="30"
                  />
                </svg>
              </div>
            ) : (
              <button
                ref={buttonRef}
                type="submit"
                disabled={isDisabled || isLoading}
                className={`block mx-auto  px-4 py-2 sm:px-6 sm:py-3 lg:px-5 lg:py-3 text-black text-sm sm:text-base lg:text-lg transition duration-300 ease-in-out transform rounded-custom focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color whitespace-nowrap ${
                  isDisabled
                    ? "bg-gray-400 cursor-not-allowed"
                    : "bg-custom-yellow hover:scale-105 hover:bg-custom-yellow"
                }`}
              >
                {t("Shopnow")}
              </button>
            )}
          </div>
        </div>
      </form>

      {isOpen &&
        ReactDOM.createPortal(
          <GalbElHabebPopup
            onClose={handelPopupGalpElhabeb}
            ref={dropdownRef}
            result={result}
          />,
          document.body
        )}
    </div>
  );
};

export default CopyLinkWithoutBackgroundV2;
